import React, { useEffect, useMemo, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import { Page, Header, HeaderCard, Section, SectionTitle, Grid, Card } from './TeamStyles';

const SECTIONS = [
  { key: 'executive', label: 'Executive' },
  { key: 'board', label: 'Board Members' },
  { key: 'management', label: 'Management' }
];

const Team = () => {
  const [page, setPage] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      api.team.getPage(),
      api.team.listMembers()
    ]).then(([p, m]) => {
      if (!mounted) return;
      setPage(p);
      setMembers(Array.isArray(m) ? m : []);
    }).catch(err => setError(err.message)).finally(() => setLoading(false));
    return () => { mounted = false; };
  }, []);

  const grouped = useMemo(() => {
    const map = { executive: [], board: [], management: [] };
    members.forEach(m => {
      const s = m.section || 'management';
      if (map[s]) map[s].push(m);
      else map.management.push(m);
    });
    return map;
  }, [members]);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;

  return (
    <Page>
      <Header>
        <HeaderCard>
          <h1>Our Team</h1>
          <p>{page?.description || ''}</p>
        </HeaderCard>
      </Header>

      {SECTIONS.map(({ key, label }) => {
        const list = grouped[key];
        if (!list || list.length === 0) return null;
        const isExecutive = key === 'executive';
        return (
          <Section key={key}>
            <SectionTitle>{label}</SectionTitle>
            <Grid $executive={isExecutive}>
              {list.map(m => (
                <Card key={m._id} $executive={isExecutive}>
                  {m.image ? <LazyImage src={m.image} alt={m.name} /> : null}
                  <h3>{m.name}</h3>
                  <h4>{m.role}</h4>
                  <p>{m.bio}</p>
                </Card>
              ))}
            </Grid>
          </Section>
        );
      })}
    </Page>
  );
};

export default Team;
